import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AxiosError } from 'axios';

const useUnauthorizedRedirect = () => {
  const navigate = useNavigate();
  const redirectIfUnauthorized = useCallback((error: AxiosError): boolean => {
    if (error?.response?.status === 401) {
      if (!window.location.pathname.includes('duplicate-user')) {
        navigate('/duplicate-user');
      }
      return true;
    }
    return false;
  }, [navigate]);

  return redirectIfUnauthorized;
};

export default useUnauthorizedRedirect;
